"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.consumptionsReducerFunction = exports.consumptionsActions = exports.ConsumptionState = exports.initialState = exports.StepDefinitions = void 0;
var immer_reducer_1 = require("immer-reducer");
require("dayjs/locale/fr");
var dayjs_1 = __importDefault(require("dayjs"));
var StepDefinitions;
(function (StepDefinitions) {
    StepDefinitions["Year"] = "Year";
    StepDefinitions["Month"] = "Month";
    StepDefinitions["Week"] = "Week";
})(StepDefinitions = exports.StepDefinitions || (exports.StepDefinitions = {}));
exports.initialState = {
    data: [],
    isRemoteReading: false,
    currentSectionSubscriptions: null,
    stepDefinition: StepDefinitions.Year,
    startDay: (0, dayjs_1.default)(new Date()).startOf('week').date(),
    startMonth: (0, dayjs_1.default)(new Date()).startOf('week').month() + 1,
    startYear: (0, dayjs_1.default)(new Date()).startOf('week').year(),
    loading: false,
    loaded: false,
    errorMsg: null,
    isEstimateConsumption: false,
    isYearlyViewOnly: false,
    downloadConsumption: {
        loading: false,
        errorMessage: null,
        success: null,
        consumptionDocument: null
    }
};
var ConsumptionState = /** @class */ (function (_super) {
    __extends(ConsumptionState, _super);
    function ConsumptionState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsumptionState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    ConsumptionState.prototype.resetStepDefinition = function () {
        this.draftState.stepDefinition = exports.initialState.stepDefinition;
        this.draftState.startMonth = exports.initialState.startMonth;
        this.draftState.startDay = exports.initialState.startDay;
        this.draftState.startYear = exports.initialState.startYear;
    };
    //initiate the fetch consumptions
    ConsumptionState.prototype.fetchConsumptions = function (payload) {
        this.draftState.loading = true;
        this.draftState.loaded = false;
        this.draftState.currentSectionSubscriptions =
            payload.sectionSubscriptionIds;
        this.draftState.errorMsg = null;
    };
    //load consumptions on success
    ConsumptionState.prototype.fetchConsumptionsSuccess = function (data) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.data = data === null || data === void 0 ? void 0 : data.consumptions;
        this.draftState.isRemoteReading = data === null || data === void 0 ? void 0 : data.isRemoteReading;
        this.draftState.isEstimateConsumption = data === null || data === void 0 ? void 0 : data.isEstimateConsumption;
        this.draftState.isYearlyViewOnly = data === null || data === void 0 ? void 0 : data.isYearlyViewOnly;
    };
    //update error message on failure
    ConsumptionState.prototype.fetchConsumptionsFailure = function (errorMsg) {
        this.draftState.loading = false;
        this.draftState.loaded = false;
        this.draftState.data = [];
        if (errorMsg) {
            this.draftState.errorMsg = errorMsg;
        }
    };
    //set the steps when navigating in graph step should be either Year , Month or Week
    //reinit all the states to the current date
    ConsumptionState.prototype.setStepDefinition = function (_a) {
        var step = _a.step, sectionSubscriptionIds = _a.sectionSubscriptionIds;
        dayjs_1.default.locale('fr');
        this.draftState.stepDefinition = step;
        this.draftState.currentSectionSubscriptions = sectionSubscriptionIds;
        if (step == 'Week') {
            var startOfWeek = (0, dayjs_1.default)(new Date()).startOf('week');
            this.draftState.startDay = startOfWeek.date();
            this.draftState.startMonth = startOfWeek.month() + 1;
            this.draftState.startYear = startOfWeek.year();
        }
        else {
            this.draftState.startDay = 1;
            var currentDate = (0, dayjs_1.default)(new Date());
            this.draftState.startMonth = currentDate.month() + 1;
            this.draftState.startYear = currentDate.year();
        }
    };
    ConsumptionState.prototype.setCurrentSectionSubscription = function (sectionSubscriptionIds) {
        this.draftState.currentSectionSubscriptions = sectionSubscriptionIds;
    };
    //action taken when the next button is clicked depends on the current step Definition
    ConsumptionState.prototype.SetNextStep = function (sectionSubscriptionIds) {
        dayjs_1.default.locale('fr');
        //current start date displayed in the graph
        this.draftState.currentSectionSubscriptions = sectionSubscriptionIds;
        var newDate = new Date(this.draftState.startYear, this.draftState.startMonth - 1, this.draftState.startDay);
        //action depends on the step definition set
        switch (this.draftState.stepDefinition) {
            case StepDefinitions.Year: {
                this.draftState.startYear = newDate.getFullYear() + 1;
                break;
            }
            case StepDefinitions.Month: {
                var currentDate = (0, dayjs_1.default)(newDate);
                var startOfMonthDate = currentDate.startOf('month');
                var nextMonthDate = startOfMonthDate.add(1, 'month');
                this.draftState.startMonth = nextMonthDate.month() + 1;
                this.draftState.startYear = nextMonthDate.year();
                this.draftState.startDay = 1;
                break;
            }
            case StepDefinitions.Week: {
                var currentDate = (0, dayjs_1.default)(newDate);
                var startOfWeekDate = currentDate.startOf('week');
                var nextWeekDate = startOfWeekDate.add(7, 'day');
                this.draftState.startDay = nextWeekDate.date();
                this.draftState.startMonth = nextWeekDate.month() + 1;
                this.draftState.startYear = nextWeekDate.year();
                break;
            }
            //throw an error if not in the steps defined
            default:
                throw new Error("Unknown step definition: ".concat(this.draftState.stepDefinition, " is not a valid step definition it should be either Year, Month or Week"));
        }
    };
    //same as set next step defined above didnt wanna mutualise the code with a function and param i think this is way more visual
    ConsumptionState.prototype.SetPreviousStep = function (sectionSubscriptionIds) {
        dayjs_1.default.locale('fr');
        this.draftState.currentSectionSubscriptions = sectionSubscriptionIds;
        var newDate = new Date(this.draftState.startYear, this.draftState.startMonth - 1, this.draftState.startDay);
        switch (this.draftState.stepDefinition) {
            case StepDefinitions.Year: {
                this.draftState.startYear = newDate.getFullYear() - 1;
                break;
            }
            case StepDefinitions.Month: {
                var currentDate = (0, dayjs_1.default)(newDate);
                var startOfMonthDate = currentDate.startOf('month');
                var previousMonthDate = startOfMonthDate.subtract(1, 'month');
                this.draftState.startMonth = previousMonthDate.month() + 1;
                this.draftState.startYear = previousMonthDate.year();
                this.draftState.startDay = 1;
                break;
            }
            case StepDefinitions.Week: {
                var currentDate = (0, dayjs_1.default)(newDate);
                var startOfWeekDate = currentDate.startOf('week');
                var previousWeekDate = startOfWeekDate.subtract(7, 'day');
                this.draftState.startDay = previousWeekDate.date();
                this.draftState.startMonth = previousWeekDate.month() + 1;
                this.draftState.startYear = previousWeekDate.year();
                break;
            }
            default:
                throw new Error("Unknown step definition: ".concat(this.draftState.stepDefinition, " is not a valid step definition it should be either Year, Month or Week"));
        }
    };
    // Download consumption
    ConsumptionState.prototype.downloadConsumptionDocument = function (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    familyId) {
        this.draftState.downloadConsumption.loading = true;
        this.draftState.downloadConsumption.errorMessage = null;
        this.draftState.downloadConsumption.success = null;
    };
    ConsumptionState.prototype.downloadConsumptionDocumentSuccess = function (consumptionDocument) {
        this.draftState.downloadConsumption.consumptionDocument =
            consumptionDocument;
        this.draftState.downloadConsumption.loading = false;
        this.draftState.downloadConsumption.errorMessage = null;
        this.draftState.downloadConsumption.success = true;
    };
    ConsumptionState.prototype.downloadConsumptionDocumentFailure = function (errorMsg) {
        this.draftState.downloadConsumption.loading = false;
        this.draftState.downloadConsumption.errorMessage = errorMsg;
        this.draftState.downloadConsumption.success = false;
    };
    ConsumptionState.prototype.resetDownloadConsumptionDocument = function () {
        this.draftState.downloadConsumption.loading =
            exports.initialState.downloadConsumption.loading;
        this.draftState.downloadConsumption.errorMessage =
            exports.initialState.downloadConsumption.errorMessage;
        this.draftState.downloadConsumption.success =
            exports.initialState.downloadConsumption.success;
    };
    return ConsumptionState;
}(immer_reducer_1.ImmerReducer));
exports.ConsumptionState = ConsumptionState;
exports.consumptionsActions = (0, immer_reducer_1.createActionCreators)(ConsumptionState);
exports.consumptionsReducerFunction = (0, immer_reducer_1.createReducerFunction)(ConsumptionState, exports.initialState);
